import { Button } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import { RanaModal } from "@nens/ranalib";

import { AppDispatch } from "../App";
import { backToStartScreen } from "../state/appState";
import { inactivateModal } from "../state/mainGui";

const LeaveSessionFinished: React.FC<Props> = (props) => {
  return (
    <RanaModal
      isOpen={true}
      onClose={props.inactivateModal}
      topBar={
        <FormattedMessage
          id="finished_modal.title_finished_modal"
          defaultMessage="Session finished. Leave?"
        />
      }
      buttons={[
        <Button variant="secondary" onClick={props.inactivateModal}>
          <FormattedMessage id="finished_modal.stay_button" defaultMessage="Stay" />
        </Button>,
        <Button variant="primary" onClick={props.backToStartScreen}>
          <FormattedMessage id="finished_modal.leave_button" defaultMessage="Leave session" />
        </Button>,
      ]}
    >
      <FormattedMessage
        id="finished_modal.simulation_finished"
        defaultMessage="The simulation is finished. You can leave this session."
      />
    </RanaModal>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    inactivateModal: () => dispatch(inactivateModal()),
    backToStartScreen: () => dispatch(backToStartScreen()),
  };
};
type Props = ReturnType<typeof mapDispatchToProps>;

export default connect(null, mapDispatchToProps)(LeaveSessionFinished);
